export default "__VITE_ASSET__CWAGHIu___"